<template>
  <v-container class="mt-4 pa-0">
    <v-card
      class="elevation-1 primary"
      :style="{ height: '85vh', overflow: 'scroll' }"
    >
      <v-toolbar color="primary" flat>
        <v-tooltip bottom>
          <v-toolbar-side-icon
            @click="loadLocations({ type: filter, limit: getLimit() })"
            slot="activator"
            icon
          >
            <v-icon>refresh</v-icon>
          </v-toolbar-side-icon>
          <span>Refresh location list</span>
        </v-tooltip>
        <v-toolbar-title class="hidden-xs-only">
          <h3>
            {{ storedType == 5 ? "Weight" : "Count" }} Queue ({{
              allLocationsModel.length
            }})
          </h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout row wrap>
          <v-flex class="text-xs-right">
            <v-select
              v-model="filter"
              :items="filters"
              item-text="text"
              item-value="value"
              label="Evaluation Type"
              color="secondary"
              class="mx-1"
              hide-details
              box
            ></v-select>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          class="primary mx-4"
          :headers="headers"
          :items="allLocationsModel"
          :pagination.sync="pagination"
          ref="dataTable"
          item-key="_id"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td
              class="text-xs-left"
              @click="$router.push(`/inventory/eval/${storedType != 7 ? 'location' : 'product'}/${props.item.id}?type=${storedType}`)"
            >
              {{
                props.item.complete_name.substring(
                  props.item.complete_name.indexOf("/") + 1
                )
              }}
            </td>
            <td
              class="text-xs-left"
              @click="$router.push(`/inventory/eval/${storedType != 7 ? 'location' : 'product'}/${props.item.id}?type=${storedType}`)"
            >
              {{
                localizeDate(props.item.last_product_move) !==
                localizeDate("12/31/1969")
                  ? localizeOdooDate(props.item.last_product_move)
                  : "Not Yet Recorded"
              }}
            </td>
            <td
              class="text-xs-left"
              @click="$router.push(`/inventory/eval/${storedType != 7 ? 'location' : 'product'}/${props.item.id}?type=${storedType}`)"
              v-if="storedType != 7"
            >
              {{
                storedType == 5
                  ? localizeDate(props.item.last_weighed) !==
                    localizeDate("12/31/1969")
                    ? localizeOdooDate(props.item.last_weighed)
                    : "Not Yet Weighed"
                  : localizeDate(props.item.last_evaluated) !==
                    localizeDate("12/31/1969")
                  ? localizeOdooDate(props.item.last_evaluated)
                  : "Not Yet Evaluated"
              }}
            </td>
            <td>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  :to="`/inventory/eval/${storedType != 7 ? 'location' : 'product'}/${props.item.id}?type=${storedType}`"
                  icon
                >
                  <v-icon>open_in_browser</v-icon>
                </v-btn>
                <span>Launch Location Eval</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Common from "@/mixins/Common";

export default {
  name: "InventoryList",
  data() {
    return {
      allLocationsModel: [],
      pagination: {
        rowsPerPage: -1,
        page: 1,
        sortBy: "complete_name"
      },
      showList: false
    };
  },

  computed: {
    ...mapGetters({
      allLocations: "inventory/getLocations",
      storedType: "inventory/getSearchType",
      settings: "settings/getSettings",
      filters: "inventory/getFilters"
    }),

    filter: {
      get() {
        return this.storedType;
      },
      set(val) {
        return this.$store.commit("inventory/setSearchType", val);
      }
    },

    headers() {
      if (this.storedType == 7) {
        return [
          { text: "Product", value: "complete_name", sortable: false },
          { text: "Last Counted", value: "last_product_move", sortable: false },
          { text: "Start Evaluation", sortable: false }
        ];
      }

      return [
        { text: "Location", value: "complete_name", sortable: false },
        { text: "Last Move", value: "last_product_move", sortable: false },
        {
          text: this.storedType == 5 ? "Last Weighed" : "Last Evaluated",
          value: this.storedType == 5 ? "last_weighed" : "last_evaluated",
          sortable: false
        },
        { text: "Start Evaluation", sortable: false }
      ];
    }
  },

  watch: {
    allLocations(val) {
      if (val) {
        const today = new Date(new Date().setHours(0, 0, 0, 0));

        this.allLocationsModel = val.filter(item => {
          if (this.storedType == 5) {
            if (
              item.last_weighed == null ||
              new Date(item.last_weighed) < today
            )
              return item;
          } else {
            if (
              item.last_evaluated == null ||
              new Date(item.last_evaluated) < today
            )
              return item;
          }
        });
      }
    },

    async filter(val) {
      await this.loadLocations({ type: val, limit: this.getLimit() });
    }
  },

  mixins: [Common],

  async beforeMount() {
    await this.getSettings("inventory");
    await this.loadLocations({ type: this.storedType, limit: this.getLimit() });
  },

  methods: {
    ...mapActions({
      loadLocations: "inventory/searchLocations",
      getSettings: "settings/getSettings"
    }),

    getLimit() {
      let limit = this.settings.filter(setting => {
        return (
          setting._id ===
          this.filters.filter(filter => {
            return filter.value === this.filter;
          })[0].settingID
        );
      })[0].value;

      return limit;
    }
  }
};
</script>

<style scoped>
>>> .v-table.theme--dark tr:hover {
  cursor: pointer;
}
>>> table.v-table th {
  font-size: 15px !important;
}
>>> table.v-table tbody td {
  font-size: 15px !important;
}
</style>
